import {
  CollectionStatus,
  CorporationApplicationKbn,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { changeAmountFormat } from "../../../utils/useTools";

function funInfoBodyList(res: any) {
  const infoBodyList = res?.map((item: any) => [
    {
      children: item.year,
      forSort: item.year,
      align: "center",
    },
    {
      children: TkGetCode(CorporationApplicationKbn, item.kbn),
      forSort: item.kbn,
    },
    {
      children: changeAmountFormat(item.premiumAmt),
      forSort: item.premiumAmt,
      align: "right",
    },
    {
      children: changeAmountFormat(item.receiveDepositAmt),
      forSort: item.receiveDepositAmt,
      align: "right",
    },
    {
      children: TkGetCode(CollectionStatus, item.receiveStatus),
      forSort: item.receiveStatus,
      align: "center",
    },
    {
      children: changeAmountFormat(item.surchargeReceiveInvoiceAmt),
      forSort: item.surchargeReceiveInvoiceAmt,
      align: "right",
    },
    {
      children: changeAmountFormat(item.surchargeReceiveDepositAmt),
      forSort: item.surchargeReceiveDepositAmt,
      align: "right",
    },
    {
      children: TkGetCode(CollectionStatus, item.surchargeReceiveStatus),
      forSort: item.surchargeReceiveStatus,
      align: "center",
    },
  ]);

  return infoBodyList ?? [];
}

export { funInfoBodyList };
